module.exports = __webpack_public_path__ + "img/arrow.a56190e9.svg";